import {
  ErrorMessage,
  isSample,
  Mtds,
  SampleCard,
  useGetSamplesQuery
} from 'prove-common'
import { sortSamplesByTakenDate } from '../../utils/sampleUtils'

type TaskSamplesTakenProps = {
  taskIds: number[] | undefined
  pageSize: number | undefined
}

export const TaskSamplesTaken = ({
  taskIds,
  pageSize
}: TaskSamplesTakenProps) => {
  const {
    data: samplePage,
    isPending: isPendingSamples,
    isError: isErrorSamples,
    error: samplesError
  } = useGetSamplesQuery({
    isEnabled: taskIds != null,
    taskIds: taskIds,
    size: pageSize
  })
  const samples = samplePage?.content?.filter(isSample)

  return (
    <Mtds.Grid>
      <Mtds.Heading as='h2' data-size='sm'>
        Prøver tatt
      </Mtds.Heading>
      {!samples?.length && <p>Ingen prøver er lagt til enda</p>}
      {isPendingSamples ? (
        <Mtds.Skeleton />
      ) : (
        sortSamplesByTakenDate(samples ?? []).map((sample) => (
          <SampleCard key={sample.id} sample={sample} view={'compact'} />
        ))
      )}
      {isErrorSamples && <ErrorMessage error={samplesError} />}
    </Mtds.Grid>
  )
}
